<template>
  <CallScreen logo="sos" title="911" />
</template>

<script>
import CallScreen from "@/components/CallScreen";

export default {
  name: "Sos",
  components: {
    CallScreen
  }
};
</script>
